export const USER_STATUS = {
  ACTIVE: 1,
  PASSIVE: 2,
  ARCHIVED: 3,
  INVITED: 4,
  DECLINED: 5,
};

export const NOTIFICATION_TYPE = {
  SUCCESS: "success",
  WARNING: "warn",
  ERROR: "error",
  INFO: "info",
};

export const USER_TYPE = {
  REGULAR: "1",
  PREMIUM: "2",
};

const DEFAULT_PRODUCTION_API_BASE_URL = "https://staging-api.eezywork.nl/api/v1";
const DEFAULT_DEVELOPMENT_API_BASE_URL = "/api/v1";
const ENV_API_BASE_URL = process.env.API_BASE_URL;
const HAS_ABSOLUTE_ENV_API_BASE_URL =
  typeof ENV_API_BASE_URL === "string" && /^https?:\/\//i.test(ENV_API_BASE_URL);

// In production, never fall back to a relative API path because static hosting may
// return index.html for /api/* requests.
export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? (HAS_ABSOLUTE_ENV_API_BASE_URL
        ? ENV_API_BASE_URL
        : DEFAULT_PRODUCTION_API_BASE_URL)
    : ENV_API_BASE_URL || DEFAULT_DEVELOPMENT_API_BASE_URL;
export const PUBLIC_PATH = process.env.PUBLIC_PATH || "/_nuxt/";
export const PUBLIC_HOST = process.env.PUBLIC_HOST || "localhost";
export const STATISTICS_REFRESH_INTERVAL = 3600000; // 1 hour in milliseconds
